import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  path: string[];
  previousPath: { page: string, url: string };
  // routerLinks: { title: string, href: string }[];
  routerLinks: { title: string, href: string }[];

  constructor(private route:ActivatedRoute, private router: Router) { } 

  ngOnInit(): void {
    this.updateRouterLinks();
    this.router.events.subscribe(x => this.updateRouterLinks());
    
  }

  updateRouterLinks() {
    this.routerLinks = [];
    this.previousPath = this.route.snapshot.data['origin'];
    this.path = this.route.snapshot.data['breadcrumb'] ? this.route.snapshot.data['breadcrumb'].split('/') : [];
    const menu = ['Empresas', 'Regras de Distribuição', 'Vistoria', 'Histórico', 'Termos de Aceite', 'Usuários']
    // this.path = window.location.pathname.split('/');
    //   this.routerLinks = this.path.map((title, i, arr) => {
    //     let href = i === 0 ? '/cadastro/vistoria' : arr.filter((x, j) => j <= i).join('/');
    //     href = href === '/cadastro' ? '' : href;
    //     if (i === 0) {
    //       title = 'Início';

    //     }
    //     return { title: title.replace(/-/g, ' '), href };
    //   });
    this.routerLinks.push({ title: 'Início', href: '/cadastro/vistoria'});
    
    this.path.forEach(item => {
      if(menu.includes(item)) {
        this.routerLinks.push({ title: item, href: ''});
      } else {
        this.routerLinks.push({ title: item, href: window.location.pathname});
      }
    })
    if(this.previousPath && menu.includes('Usuários')) {
        const companyId = JSON.parse(localStorage.getItem('insurance')).companyId;
        this.routerLinks.splice(2,0, { title: this.previousPath.page, href: this.previousPath.url + companyId});
    }
  }
}
